var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (fieldsetCounter, globals, id, validationId) {
      pug_mixins["summary-box"] = pug_interp = function(selectedCompany, save, disabled, cyData){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv class=\"summary-box isTransparent\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"xsmall-12 medium-6 large-6 columns\"\u003E";
if (selectedCompany) {
pug_html = pug_html + "\u003Cspan class=\"summary-box__title\"\u003E\u003Cstrong\u003EFirma:\u003C\u002Fstrong\u003E\u003Cspan\u003E" + (pug.escape(null == (pug_interp = ' '+ selectedCompany) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + "\u003Cspan class=\"hide-for-small-only\"\u003E&nbsp;\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"xsmall-12 medium-6 large-6 columns text-right pull-right\"\u003E";
block && block();
if (save) {
pug_html = pug_html + "\u003Cbutton" + (" class=\"button button-primary isOutline\""+pug.attr("ng-click", save, true, true)+pug.attr("ng-disabled", disabled, true, true)+pug.attr("data-cy", cyData, true, true)) + "\u003ESpeichern\u003C\u002Fbutton\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};



















pug_mixins["input"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.type) {
attributes.type = 'text'
}
if (!attributes.attributes) {
attributes.attributes = {}
}
if (!attributes.groupAttributes) {
attributes.groupAttributes = {}
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": pug.classes(["form-group",attributes.groupHtmlClass], [false,false])},attributes.groupAttributes]), true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (pug.attr("class", pug.classes(["control-label",attributes.labelHtmlClass], [false,true]), false, true)+pug.attr("for", id, true, true)) + "\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Flabel\u003E";
}
if (attributes.divTitle) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["control-label",attributes.divTitleHtmlClass], [false,true]), false, true)) + "\u003E" + (null == (pug_interp = attributes.divTitle) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cinput" + (pug.attrs(pug.merge([{"class": pug.classes(["form-control",attributes.fieldHtmlClass], [false,true]),"id": pug.escape(id),"type": pug.escape(attributes.type),"placeholder": pug.escape(attributes.placeholder),"ng-model": pug.escape(attributes.key),"ng-disabled": pug.escape(attributes.readonly),"name": pug.escape(id),"value": pug.escape(attributes.value),"required": pug.escape(attributes.required),"ng-pattern": pug.escape(attributes['ng-pattern']),"disabled": pug.escape(attributes.disabled),"data-cy": pug.escape(attributes['data-cy'])},attributes.attributes]), true)) + "\u003E";
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (attributes.validationMessages) {
validationId = '"'+ id +'"'
if (attributes.validationId) {
validationId = attributes.validationId
}
pug_mixins["validationMessages"].call({
attributes: {"key": pug.escape(validationId),"validationMessages": pug.escape(attributes.validationMessages)}
});
}
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};































































pug_mixins["switchbox"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["double-label-switch",attributes.containerHtmlClass], [false,false]), false, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (pug.attr("class", pug.classes([attributes.labelHtmlClass], [true]), false, true)+pug.attr("for", id, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"switch round large\"\u003E\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+" type=\"checkbox\""+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("id", id, true, true)+pug.attr("name", id, true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-true-value", attributes['ng-true-value'], true, true)+pug.attr("ng-init", attributes['ng-init'], true, true)+pug.attr("ng-false-value", attributes['ng-false-value'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E\u003Clabel" + (" class=\"switch__label\""+pug.attr("for", id, true, true)) + "\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};






































pug_mixins["radio"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.title && attributes.name) {
attributes.title = attributes.name
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key + '-' + attributes.index
}
pug_html = pug_html + "\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+pug.attr("id", id, true, true)+" type=\"radio\""+pug.attr("required", attributes.required, true, true)+pug.attr("name", attributes.key, true, true)+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("value", attributes.value, true, true)+pug.attr("ng-value", attributes['ng-value'], true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (" class=\"radio-inline\""+pug.attr("for", attributes.key + '-' + attributes.index, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
};






































































pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (!fieldsetCounter) {
fieldsetCounter = 0
}





















pug_html = pug_html + "\u003Cdiv class=\"cockpit_arbeitnmv-wrapper\"\u003E";
pug_mixins["summary-box"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"reset-line-height\"\u003E\u003C!--button.button.button-primary.isOutline(--\u003E\u003C!--  ng-click='EmployeeAdministrationCtrl.openDirectBornusDialog()'--\u003E\u003C!--  ng-if=\"EmployeeAdministrationCtrl.iAmDirectBonus || EmployeeAdministrationCtrl.iAmSpecialAdvisor\"--\u003E\u003C!--) Bonus--\u003E\u003Cbutton class=\"button button-primary isOutline\" ng-click=\"EmployeeAdministrationCtrl.inviteAll($event)\" ng-disabled=\"EmployeeAdministrationCtrl.customerConfig.deactivated\" ng-if=\"EmployeeAdministrationCtrl.iAmSpecialAdvisor || EmployeeAdministrationCtrl.iAmEmployer\"\u003EAlle einladen\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary isOutline\" ng-click=\"EmployeeAdministrationCtrl.arbeitnehmerAnlegen()\" ng-if=\"!EmployeeAdministrationCtrl.iAmEmployer\" data-cy=\"vn.cockpit.registration.customerToolbar.buttonAdvisorRegistration\"\u003EAN anlegen\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary isOutline\" ng-click=\"EmployeeAdministrationCtrl.mitarbeiterImportieren()\" ng-if=\"EmployeeAdministrationCtrl.iAmSpecialAdvisor\"\u003EMitarbeiter importieren\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";
}
}, '{{ EmployeeAdministrationCtrl.customer.name }}');
pug_html = pug_html + "\u003Cdiv class=\"cockpit-panel\" ng-if=\"!EmployeeAdministrationCtrl.iAmEmployer\"\u003E\u003Cdiv class=\"cockpit-panel__title\"\u003EProjekt Einstellungen\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel__body\" ng-class=\"{ red:EmployeeAdministrationCtrl.customerConfig.fixated }\"\u003E\u003Cdiv class=\"row form-group\"\u003E\u003Cdiv class=\"small-9 columns\"\u003E";
pug_mixins["switchbox"].call({
attributes: {"id": "switchPortal","title": "Portalkonfiguration fixiert","key": "EmployeeAdministrationCtrl.customerConfig.fixated","labelHtmlClass": "switchbox-float-label","readonly": "!EmployeeAdministrationCtrl.iAmSpecialAdvisor","ng-change": "EmployeeAdministrationCtrl.fixate()"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel\" ng-if=\"EmployeeAdministrationCtrl.iAmEmployer\"\u003E\u003Cdiv class=\"cockpit-panel__title\"\u003EArbeitnehmerverwaltung und Dokumentenübersicht\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel__body\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cp\u003EHier finden Sie die Übersicht über alle registrierten Arbeitnehmer. In der Übersicht wird in dem Button der NEO-Status ausgegeben. Der Punkt am Ende zeigt den Portalstatus an.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel\" overlay=\"EmployeeAdministrationCtrl.generatingFile\"\u003E\u003Cdiv class=\"cockpit-panel__title\"\u003EImport & Export\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel__body\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns align-spaced\"\u003E\u003Cbutton class=\"button button-primary isOutline\" ng-click=\"EmployeeAdministrationCtrl.generateCSV()\" data-cy=\"vn.cockpit.activationFlow.employeeManagement.buttonEmployeeCsv\"\u003EMitarbeiterdaten CSV\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary isOutline\" ng-click=\"EmployeeAdministrationCtrl.generateCustomerLocationsCSV()\"\u003EStandorte CSV\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary isOutline\" ng-click=\"EmployeeAdministrationCtrl.fixUser()\" ng-disabled=\"EmployeeAdministrationCtrl.loading || EmployeeAdministrationCtrl.customerConfig.deactivated\"\u003EFix User\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary isOutline\" ng-if=\"EmployeeAdministrationCtrl.iAmSpecialAdvisor\" ng-click=\"EmployeeAdministrationCtrl.setAllToKorrektur()\"\u003ENachberatung {{EmployeeAdministrationCtrl.set_all_to_korrektur === true ? 'an': 'aus'}}\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary isOutline\" ng-click=\"EmployeeAdministrationCtrl.createEmployeesWithSachbezugList(&quot;csv&quot;)\"\u003E{{ EmployeeAdministrationCtrl.generatingFile.csv ? \"Warte Bitte, erzeuge CSV\" : \"Erstelle Sachbezugs-CSV\" }}\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary isOutline\" ng-click=\"EmployeeAdministrationCtrl.createEmployeesWithSachbezugList(&quot;pdf&quot;)\"\u003E{{ EmployeeAdministrationCtrl.generatingFile.pdf ? \"Warte Bitte, erzeuge PDF\" : \"Erstelle Sachbezugs-PDF\" }}\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel\"\u003E\u003Cdiv class=\"cockpit-panel__title\"\u003ESuche & Filter: {{ EmployeeAdministrationCtrl.filtered_employees.length}} von {{ EmployeeAdministrationCtrl.employees.length}} Arbeitnehmer ausgewählt\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel__body employee-filters-containter\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-4 filter-input\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "filters.id","title": "ValueNetID","attributes": {"ng-change":"EmployeeAdministrationCtrl.filterEmployees()","ng-model-options":"{ debounce: 300 }"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-4 filter-input\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "filters.personal_number","title": "Personalnummer","attributes": {"ng-change":"EmployeeAdministrationCtrl.filterEmployees()","ng-model-options":"{ debounce: 300 }"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-4 filter-input\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "filters.name","title": "Vorname Name","attributes": {"ng-change":"EmployeeAdministrationCtrl.filterEmployees()","ng-model-options":"{ debounce: 300 }"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-4 filter-input\"\u003E\u003Cdiv\u003E\u003Clabel class=\"control-label\"\u003EUser-Status\u003C\u002Flabel\u003E\u003Cui-select ng-model=\"filters.made_status.selected\" theme=\"select2\" title=\"Made Status Filter\" search-enabled=\"false\" multiple close-on-select=\"false\" style=\"width:100%\" ng-change=\"EmployeeAdministrationCtrl.filterEmployees()\" ng-model-options=\"{ debounce: 1000 }\"\u003E\u003Cui-select-match placeholder=\"Select Made Status\" allow-clear=\"true\"\u003E{{$item.name}}\u003C\u002Fui-select-match\u003E\u003Cui-select-choices repeat=\"status in filters.made_status.options track by $index\"\u003E\u003Cspan ng-bind=\"status.name\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fui-select-choices\u003E\u003C\u002Fui-select\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-4 filter-input\"\u003E\u003Cdiv\u003E\u003Clabel class=\"control-label\"\u003ENEO-Status\u003C\u002Flabel\u003E\u003Cui-select ng-model=\"filters.neo_status.selected\" theme=\"select2\" title=\"Neo Status Filter\" search-enabled=\"false\" multiple close-on-select=\"false\" style=\"width:100%\" ng-change=\"EmployeeAdministrationCtrl.filterEmployees()\" ng-model-options=\"{ debounce: 1000 }\"\u003E\u003Cui-select-match placeholder=\"Select Neo Status...\"\u003E{{$item.name}}\u003C\u002Fui-select-match\u003E\u003Cui-select-choices repeat=\"neo_status in filters.neo_status.options | orderBy: 'display'\"\u003E\u003Cspan ng-bind=\"neo_status.display\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fui-select-choices\u003E\u003C\u002Fui-select\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-4 filter-input\"\u003E\u003Cdiv\u003E\u003Clabel class=\"control-label\"\u003ELetzter Login\u003C\u002Flabel\u003E\u003Cui-select ng-model=\"filters.last_login.selected\" theme=\"select2\" title=\"Last Login Filter\" search-enabled=\"false\" multiple close-on-select=\"false\" style=\"width:100%\" ng-change=\"EmployeeAdministrationCtrl.filterEmployees()\" ng-model-options=\"{ debounce: 1000 }\"\u003E\u003Cui-select-match placeholder=\"Select Last Login\"\u003E{{$item.display}}\u003C\u002Fui-select-match\u003E\u003Cui-select-choices repeat=\"option in filters.last_login.options\"\u003E\u003Cspan ng-bind=\"option.display\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fui-select-choices\u003E\u003C\u002Fui-select\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-2\"\u003E";
pug_mixins["switchbox"].call({
attributes: {"id": "switchTestclients","key": "filters.hide_testclients","title": "keine Test-MA","ng-change": "EmployeeAdministrationCtrl.filterEmployees()"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns\"\u003ESortieren:\u003Cselect class=\"simple-select\" ng-model=\"filter.order\" vn-number-to-bool\u003E\u003Coption value=\"0\"\u003EA-Z\u003C\u002Foption\u003E\u003Coption value=\"1\"\u003EZ-A\u003C\u002Foption\u003E\u003C\u002Fselect\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"list-box\" overlay=\"EmployeeAdministrationCtrl.loading\"\u003E\u003Cdiv class=\"list-box__row\" ng-class=\"{'toggable-content-open': toggleContentShowable}\" ng-repeat=\"employeeData in EmployeeAdministrationCtrl.filtered_employees | orderBy: 'name': filter.order\" toggable-content=\"toggableStatus\"\u003E\u003Ctoggable-content-toggler ng-init=\"employee = {}\" ng-click=\"EmployeeAdministrationCtrl.previewCalculation(employeeData, employee, toggleContentShowable)\"\u003E\u003Cdiv class=\"list-box__item\"\u003E\u003Cspan class=\"list-box__itemTitle\" ng-click=\"togglerClicked()\"\u003E\u003Cdiv class=\"toggable-state-feedback\"\u003E\u003C\u002Fdiv\u003E\u003Cspan class=\"user-name\"\u003E{{ employeeData.name }}, {{ employeeData.vorname }}\u003C\u002Fspan\u003E\u003Cdiv class=\"status-container\" ng-if=\"EmployeeAdministrationCtrl.accessList[employeeData.id] &amp;&amp; !EmployeeAdministrationCtrl.iAmEmployer\"\u003E\u003Cspan class=\"neo-status\" ng-class=\"['status-'+ EmployeeAdministrationCtrl.accessList[employeeData.id].neoStatus.color ]\" ng-click=\"EmployeeAdministrationCtrl.changeNeoStatus(employeeData.id, $event)\" ng-bind-html=\"EmployeeAdministrationCtrl.accessList[employeeData.id].neoStatus.display\" ng-if=\"!EmployeeAdministrationCtrl.iAmGAdvisor &amp;&amp; !EmployeeAdministrationCtrl.iAmAdvisor &amp;&amp; !EmployeeAdministrationCtrl.iAmEmployer\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"neo-status\" ng-class=\"['status-'+ EmployeeAdministrationCtrl.accessList[employeeData.id].neoStatus.color ]\" ng-bind-html=\"EmployeeAdministrationCtrl.accessList[employeeData.id].neoStatus.display\" ng-if=\"EmployeeAdministrationCtrl.iAmGAdvisor || EmployeeAdministrationCtrl.iAmAdvisor || EmployeeAdministrationCtrl.iAmEmployer\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"access-state\" ng-class=\"EmployeeAdministrationCtrl.parseStatus( employeeData.id )\"\u003E&#x25cf;\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cimg ng-if=\"EmployeeAdministrationCtrl.employeeHasBikeleasing(employeeData.id)\" ng-src=\"\u002Fassets\u002Fimg\u002FBikeleasing_b.png\"\u003E\u003Cimg ng-if=\"EmployeeAdministrationCtrl.hasPCLeasing(employeeData.id)\" ng-src=\"\u002Fassets\u002Fimg\u002Fpc_icon.png\"\u003E\u003C\u002Fspan\u003E\u003Cdiv class=\"row second-row\"\u003E\u003Cdiv class=\"columns text-right an-verwaltung-padding\"\u003E\u003Cbutton class=\"button button-primary isOutline\" ng-click=\"EmployeeAdministrationCtrl.openDirectBonusDialog(employeeData, $event)\" ng-if=\"EmployeeAdministrationCtrl.hasDirectBonusProjectActivated()\"\u003EBonus\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary isOutline\" ng-if=\"(EmployeeAdministrationCtrl.iAmGAdvisor || EmployeeAdministrationCtrl.iAmAdvisor) &amp;&amp; employee._id\" ui-sref=\"inApp.neo.side.berater({employeeId: employeeData.id})\"\u003Ezum Rechner\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary isOutline\" ng-click=\"EmployeeAdministrationCtrl.purgeCidaasUser(employeeData.id)\" ng-if=\"!EmployeeAdministrationCtrl.iAmEmployer &amp;&amp; !!employee.cidaas_sub\"\u003ECidaas entfernen\u003C\u002Fbutton\u003E\u003C!--button.button.button-primary.isOutline(--\u003E\u003C!--  ng-click='EmployeeAdministrationCtrl.arbeitnehmerFreischalten(employeeData, employee._id)'--\u003E\u003C!--  ng-disabled='EmployeeAdministrationCtrl.customerConfig.deactivated'--\u003E\u003C!--  ng-if='!EmployeeAdministrationCtrl.iAmEmployer && employee._id'--\u003E\u003C!--) {{ employee.is_invited_in_cidaas ? 'Erneut Einladen' : 'Einladen' }}--\u003E\u003Cbutton class=\"button button-primary isOutline\" ng-click=\"EmployeeAdministrationCtrl.arbeitnehmerFreischalten(employeeData, employee._id)\" ng-disabled=\"EmployeeAdministrationCtrl.customerConfig.deactivated\" ng-if=\"EmployeeAdministrationCtrl.isTheUserInvitable(employeeData)\"\u003EEinladen\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary isOutline\" ng-click=\"EmployeeAdministrationCtrl.arbeitnehmerFreischalten(employeeData, employee._id)\" ng-disabled=\"EmployeeAdministrationCtrl.customerConfig.deactivated\" ng-if=\"EmployeeAdministrationCtrl.isTheUserReinvitable(employeeData)\"\u003EErneut Einladen\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary isOutline\" ng-click=\"EmployeeAdministrationCtrl.arbeitnehmerFixUser(employeeData)\" ng-disabled=\"EmployeeAdministrationCtrl.customerConfig.deactivated\" ng-if=\"(EmployeeAdministrationCtrl.iAmSpecialAdvisor || EmployeeAdministrationCtrl.iAmAdvisor) &amp;&amp; !employee._id\"\u003EFreischalten\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary isOutline\" ng-click=\"EmployeeAdministrationCtrl.arbeitnehmerAnlegen(employeeData)\" ng-if=\"!EmployeeAdministrationCtrl.iAmEmployer &amp;&amp; employee._id\"\u003EBearbeiten\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary isOutline\" ng-click=\"EmployeeAdministrationCtrl.arbeitnehmerAnlegen(employeeData)\" ng-if=\"EmployeeAdministrationCtrl.iAmEmployer\"\u003EMitarbeiterdetails ansehen\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary isOutline\" ng-click=\"EmployeeAdministrationCtrl.arbeitnehmerContactDetails(employeeData)\" ng-if=\"!EmployeeAdministrationCtrl.iAmEmployer\"\u003EKontaktdetails\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary isOutline\" ng-click=\"EmployeeAdministrationCtrl.activateUser(employeeData.id)\" ng-disabled=\"employee.active\" ng-if=\"(EmployeeAdministrationCtrl.iAmSpecialAdvisor || EmployeeAdministrationCtrl.iAmAdvisor) &amp;&amp; employee._id &amp;&amp; !employee.active\"\u003EAktivieren\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary isOutline\" ng-click=\"EmployeeAdministrationCtrl.deactivate(employeeData.id)\" ng-disabled=\"!employee.active\" ng-if=\"EmployeeAdministrationCtrl.iAmSpecialAdvisor &amp;&amp; employee._id &amp;&amp; employee.active\"\u003EDeaktivieren\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary isOutline\" ng-click=\"EmployeeAdministrationCtrl.showStatusLog(employeeData)\" ng-if=\"employeeData.id\"\u003EStatus Log\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary isOutline\" ng-click=\"EmployeeAdministrationCtrl.setKorrekturStatus(employeeData.id, true)\" ng-if=\"EmployeeAdministrationCtrl.iAmSpecialAdvisor &amp;&amp; employee._id &amp;&amp; EmployeeAdministrationCtrl.isStatusFromKorrekturFlow(EmployeeAdministrationCtrl.accessList[employeeData.id].neoStatus)\"\u003ENachberatung\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary isOutline\" ng-if=\"EmployeeAdministrationCtrl.iAmGAdvisor || EmployeeAdministrationCtrl.iAmAdvisor\" ng-click=\"EmployeeAdministrationCtrl.become( employeeData )\"\u003ENutzer übernehmen\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Ftoggable-content-toggler\u003E\u003Cdiv class=\"list-box__item__content\" toggable-content-content ng-if=\"toggableStatus\"\u003E" + (null == (pug_interp = require("./_toggableContent.pug").call(this, locals)) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "fieldsetCounter" in locals_for_with ?
        locals_for_with.fieldsetCounter :
        typeof fieldsetCounter !== 'undefined' ? fieldsetCounter : undefined, "globals" in locals_for_with ?
        locals_for_with.globals :
        typeof globals !== 'undefined' ? globals : undefined, "id" in locals_for_with ?
        locals_for_with.id :
        typeof id !== 'undefined' ? id : undefined, "validationId" in locals_for_with ?
        locals_for_with.validationId :
        typeof validationId !== 'undefined' ? validationId : undefined));
    ;;return pug_html;};
module.exports = template;